import { FlexibleModelBase, FlexibleBaseSpecification } from './flexible_base';

export interface FlexibleRockBottomSpecification extends FlexibleBaseSpecification {}

export class FlexibleRockBottomModel extends FlexibleModelBase {
	constructor(spec: FlexibleRockBottomSpecification) {
		super(spec);
	}
}
